/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type PersonalityType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type UserGender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type OwnChatRoomOnUseMatchQueryVariables = Exact<{
  id: string | number;
}>;


export type OwnChatRoomOnUseMatchQuery = { ownChatRoom: { id: string, status: Types.ChatRoomStatus, updatedAt: TimeString, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, userLatestReadMessageGUID: string | null, match: { id: string, normalMessageChatReplyMatchSetting: { disabledUntil: TimeString | null } }, user: { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, financialServicesAgent: string | null, userRegistrationInflowSource: string | null, address: { prefecture: string, city: string } | null, diagnosisResult: { personality: { type: Types.PersonalityType, title: string, description: string } } | null } | null, planner: { id: string, name: string, avatar: any, chatParticipant: { id: string } | null } } | null };

export type ColleagueChatRoomOnUseMatchQueryVariables = Exact<{
  id: string | number;
}>;


export type ColleagueChatRoomOnUseMatchQuery = { colleagueChatRoom: { id: string, status: Types.ChatRoomStatus, updatedAt: TimeString, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, userLatestReadMessageGUID: string | null, match: { id: string, normalMessageChatReplyMatchSetting: { disabledUntil: TimeString | null } }, user: { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, financialServicesAgent: string | null, userRegistrationInflowSource: string | null, address: { prefecture: string, city: string } | null, diagnosisResult: { personality: { type: Types.PersonalityType, title: string, description: string } } | null } | null, planner: { id: string, name: string, avatar: any, chatParticipant: { id: string } | null } } | null };

export type UseMatchChatRoomFragment = { id: string, status: Types.ChatRoomStatus, updatedAt: TimeString, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, userLatestReadMessageGUID: string | null, match: { id: string, normalMessageChatReplyMatchSetting: { disabledUntil: TimeString | null } }, user: { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, financialServicesAgent: string | null, userRegistrationInflowSource: string | null, address: { prefecture: string, city: string } | null, diagnosisResult: { personality: { type: Types.PersonalityType, title: string, description: string } } | null } | null, planner: { id: string, name: string, avatar: any, chatParticipant: { id: string } | null } };

export type ChatRoomMatchFragment = { id: string, normalMessageChatReplyMatchSetting: { disabledUntil: TimeString | null } };

export type MatchPlannerFragment = { id: string, name: string, avatar: any };

export type DiagnosisResultFragment = { personality: { type: Types.PersonalityType, title: string, description: string } };

export type OwnChatRoomListUserMatchFragment = { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, financialServicesAgent: string | null, userRegistrationInflowSource: string | null, address: { prefecture: string, city: string } | null, diagnosisResult: { personality: { type: Types.PersonalityType, title: string, description: string } } | null };

export const ChatRoomMatchFragmentDoc = gql`
    fragment ChatRoomMatch on Match {
  id
  normalMessageChatReplyMatchSetting {
    disabledUntil
  }
}
    `;
export const DiagnosisResultFragmentDoc = gql`
    fragment DiagnosisResult on DiagnosisResult {
  personality {
    type
    title
    description
  }
}
    `;
export const OwnChatRoomListUserMatchFragmentDoc = gql`
    fragment OwnChatRoomListUserMatch on User {
  id
  birthYear
  nickname
  gender
  livingPrefecture
  address {
    prefecture
    city
  }
  diagnosisResult {
    ...DiagnosisResult
  }
  financialServicesAgent
  userRegistrationInflowSource
}
    ${DiagnosisResultFragmentDoc}`;
export const UseMatchChatRoomFragmentDoc = gql`
    fragment UseMatchChatRoom on ChatRoom {
  id
  status
  updatedAt
  hasUnreadMessage
  hasUnrepliedMessage
  userLatestReadMessageGUID
  match {
    ...ChatRoomMatch
  }
  user {
    ...OwnChatRoomListUserMatch
  }
  planner {
    id
    name
    avatar
    chatParticipant {
      id
    }
  }
}
    ${ChatRoomMatchFragmentDoc}
${OwnChatRoomListUserMatchFragmentDoc}`;
export const MatchPlannerFragmentDoc = gql`
    fragment MatchPlanner on Planner {
  id
  name
  avatar
}
    `;
export const OwnChatRoomOnUseMatchDocument = gql`
    query OwnChatRoomOnUseMatch($id: ID!) {
  ownChatRoom(id: $id) {
    ...UseMatchChatRoom
  }
}
    ${UseMatchChatRoomFragmentDoc}`;

/**
 * __useOwnChatRoomOnUseMatchQuery__
 *
 * To run a query within a Vue component, call `useOwnChatRoomOnUseMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnChatRoomOnUseMatchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOwnChatRoomOnUseMatchQuery({
 *   id: // value for 'id'
 * });
 */
export function useOwnChatRoomOnUseMatchQuery(variables: OwnChatRoomOnUseMatchQueryVariables | VueCompositionApi.Ref<OwnChatRoomOnUseMatchQueryVariables> | ReactiveFunction<OwnChatRoomOnUseMatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>(OwnChatRoomOnUseMatchDocument, variables, options);
}
export function useOwnChatRoomOnUseMatchLazyQuery(variables?: OwnChatRoomOnUseMatchQueryVariables | VueCompositionApi.Ref<OwnChatRoomOnUseMatchQueryVariables> | ReactiveFunction<OwnChatRoomOnUseMatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>(OwnChatRoomOnUseMatchDocument, variables, options);
}
export type OwnChatRoomOnUseMatchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>;
export const ColleagueChatRoomOnUseMatchDocument = gql`
    query ColleagueChatRoomOnUseMatch($id: ID!) {
  colleagueChatRoom(id: $id) {
    ...UseMatchChatRoom
  }
}
    ${UseMatchChatRoomFragmentDoc}`;

/**
 * __useColleagueChatRoomOnUseMatchQuery__
 *
 * To run a query within a Vue component, call `useColleagueChatRoomOnUseMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useColleagueChatRoomOnUseMatchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useColleagueChatRoomOnUseMatchQuery({
 *   id: // value for 'id'
 * });
 */
export function useColleagueChatRoomOnUseMatchQuery(variables: ColleagueChatRoomOnUseMatchQueryVariables | VueCompositionApi.Ref<ColleagueChatRoomOnUseMatchQueryVariables> | ReactiveFunction<ColleagueChatRoomOnUseMatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>(ColleagueChatRoomOnUseMatchDocument, variables, options);
}
export function useColleagueChatRoomOnUseMatchLazyQuery(variables?: ColleagueChatRoomOnUseMatchQueryVariables | VueCompositionApi.Ref<ColleagueChatRoomOnUseMatchQueryVariables> | ReactiveFunction<ColleagueChatRoomOnUseMatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>(ColleagueChatRoomOnUseMatchDocument, variables, options);
}
export type ColleagueChatRoomOnUseMatchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>;